export default __webpack_public_path__ + "static/media/1653.839da152.png";